<app-pagetoolbar icon="manage_accounts" label="Participant History"> </app-pagetoolbar>

<app-participant-history-box [recipient]="recipient" [donor]="donor" [timelineHistory]="timelineHistory" style="width: 100%"> </app-participant-history-box>
